
import { mixins, Options } from 'vue-class-component'
import BaseFormMixin from '@/components/common/mixins/BaseFormMixin.vue'
import { maska } from 'maska'
import { IDateRangePicker, IOverViewRequest } from '@/utils/types'
import { ChartModel } from '@/models/chart-model'
import { ACTION_FORM } from '@/store/actions'
import { Formater } from '@/utils/formater'
import { Watch } from 'vue-property-decorator'
import { DatetimeUtils } from '@/utils/datetime'
import EChart from '@/components/app/EChart.vue'
import CLoading from '@/components/common/ui/CLoading.vue'
import DateRangeSelectorV2 from '@/components/common/ui/DateRangeSelectorV2.vue'

@Options({
  components: { DateRangeSelectorV2, CLoading, EChart },
  directives: { maska },
})
export default class ChartOfAssetDetails extends mixins(BaseFormMixin) {
  loading = true
  firstLoad = true
  componentKey = 1
  chart_title = ''
  currentDateType = ''

  dateRange: IDateRangePicker = {
    startDate: '',
    endDate: '',
  }

  friendsChart: ChartModel = new ChartModel([], [])

  campaignsStatistic: IOverViewRequest[] = []

  get selectedAppId() {
    return this.$route.params.app_id as string
  }

  get selectedAssetId() {
    return this.$route.params.asset_id || ''
  }

  get selectedAssetType() {
    return this.$route.params.asset_type || ''
  }

  async fetchSelectingApp() {
    this.campaignsStatistic = []
    if (!this.selectedAssetId) {
      return
    }

    this.loading = true

    const resp = await this.$store.dispatch(ACTION_FORM.OVERVIEW_DETAIL, {
      app_id: this.selectedAppId,
      asset_id: this.selectedAssetId,
      asset_type: this.selectedAssetType,
      is_test_mode: false,
      date_from: DatetimeUtils.formatDate(this.dateRange.startDate),
      date_to: DatetimeUtils.formatDate(this.dateRange.endDate),
    })
    if (resp) {
      // eslint-disable-next-line
      this.campaignsStatistic = resp['story']
    }
    this.initCharts()
    this.loading = false
  }

  initCharts(): void {
    this.friendsChart = new ChartModel([], [])
    const total = this.campaignsStatistic.length
    for (let index = total - 1; index >= 0; index--) {
      const item = this.campaignsStatistic[index]
      this.friendsChart.xAxis.push(item.date)
    }

    this.componentKey++
  }

  get seriesData() {
    const delivered: number[] = []
    const total_user_of_goal: number[] = []
    const gtr: number[] = []
    const total_click: number[] = []
    const success_rate: number[] = []
    const success_count: number[] = []
    const total = this.campaignsStatistic.length
    for (let index = total - 1; index >= 0; index--) {
      const item = this.campaignsStatistic[index]
      delivered.push(item.delivered)
      total_user_of_goal.push(item.total_user_of_goal)
      gtr.push(item.gtr)
      total_click.push(item.total_click)
      success_rate.push(item.success_rate)
      success_count.push(item.success_count)
    }

    return [
      {
        name: this.$t('label.delivered'),
        type: 'line',
        data: delivered,
      },
      {
        name: this.$t('label.total_user_of_goal'),
        type: 'line',
        data: total_user_of_goal,
      },
      {
        name: this.$t('label.gtr'),
        type: 'line',
        data: gtr,
      },
      {
        name: this.$t('label.total_click'),
        type: 'line',
        data: total_click,
      },
      {
        name: this.$t('label.success_rate'),
        type: 'line',
        data: success_rate,
      },
      {
        name: this.$t('label.success_count'),
        type: 'line',
        data: success_count,
      },
    ]
  }

  numberWithCommas(num) {
    return Formater.numberFormat(num)
  }

  changeDateRange(value) {
    if (this.firstLoad) {
      return
    }
    this.dateRange = value
    this.fetchSelectingApp()
  }

  changeDate(type) {
    if (type === this.currentDateType) {
      this.currentDateType = ''
    } else {
      this.currentDateType = type
    }
  }

  @Watch('currentDateType')
  setDateRange() {
    this.dateRange = DatetimeUtils.getDateRange(this.currentDateType)

    this.fetchSelectingApp()
  }

  @Watch('selectedStoryId', { immediate: true })
  selectedStoryIdChanged() {
    this.dateRange = DatetimeUtils.getDateRange('last7Days')
    this.fetchSelectingApp()
    this.firstLoad = false
  }

  mounted() {
    this.chart_title = this.$t('label.initial.chart_title')
  }
}
